import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  // Categories
  getCategories: (params) => axios.get(`${API}/categories`, { params }),
  
  // Places
  getPlaces: (params) => axios.get(`${API}/places`, { params }),
  suggestPlaces: (q, lang) => axios.get(`${API}/places/suggest`, { params: { q, lang } }),
  getPlace: (id, lat, lon, refreshGoogle = false) => axios.get(`${API}/places/${id}`, { params: { lat, lon, refresh_google: refreshGoogle } }),
  createPlace: (data) => axios.post(`${API}/places`, data),
  updatePlace: (id, data) => axios.put(`${API}/places/${id}`, data),
  deletePlace: (id) => axios.delete(`${API}/places/${id}`),
  
  // Favorites
  getFavorites: (lat, lon) => axios.get(`${API}/favorites`, { params: { lat, lon } }),
  addFavorite: (placeId) => axios.post(`${API}/favorites/${placeId}`),
  removeFavorite: (placeId) => axios.delete(`${API}/favorites/${placeId}`),
  checkFavorite: (placeId) => axios.get(`${API}/favorites/check/${placeId}`),
  
  // Itineraries
  getItineraries: () => axios.get(`${API}/itineraries`),
  getItinerary: (id, lat, lon) => axios.get(`${API}/itineraries/${id}`, { params: { lat, lon } }),
  createItinerary: (data) => axios.post(`${API}/itineraries`, data),
  deleteItinerary: (id) => axios.delete(`${API}/itineraries/${id}`),
  
  // Weather zones
  getWeatherZones: () => axios.get(`${API}/weather-zones`),
  // Webcams (mapa único Tiempo)
  getWebcams: () => axios.get(`${API}/webcams`),
  getWebcamForecast: (id, point = 'main') => axios.get(`${API}/webcams/${id}/forecast`, { params: { point } }),
  getSeaState: () => axios.get(`${API}/webcams/sea`),
  getSpots: () => axios.get(`${API}/spots`),
  getSpotsSea: () => axios.get(`${API}/spots/sea`),
  adminGetSpots: () => axios.get(`${API}/admin/spots`),
  adminCreateSpot: (data) => axios.post(`${API}/admin/spots`, data),
  adminUpdateSpot: (id, data) => axios.patch(`${API}/admin/spots/${id}`, data),
  adminDeleteSpot: (id) => axios.delete(`${API}/admin/spots/${id}`),
  // Compartir
  getShareLink: (kind, id, lang) => axios.get(`${API}/share/link/${kind}${id ? `/${id}` : ''}`, { params: { lang } }),
  recordShare: (data) => axios.post(`${API}/share/event`, data),
  adminShareStats: (params) => axios.get(`${API}/admin/share/stats`, { params }),
  adminGetWebcams: () => axios.get(`${API}/admin/webcams`),
  adminCreateWebcam: (data) => axios.post(`${API}/admin/webcams`, data),
  adminUpdateWebcam: (id, data) => axios.patch(`${API}/admin/webcams/${id}`, data),
  adminDeleteWebcam: (id) => axios.delete(`${API}/admin/webcams/${id}`),
  
  // Google Places
  searchGooglePlaces: (query) => axios.get(`${API}/google/search`, { params: { query } }),
  getGooglePlaceDetails: (placeId) => axios.get(`${API}/google/place/${placeId}`),

  // AI Summary
  generatePlaceSummary: (placeId, instagramUrl) => axios.post(`${API}/places/${placeId}/generate-summary`, null, { params: instagramUrl ? { instagram_url: instagramUrl } : {} }),
  generateAllSummaries: () => axios.post(`${API}/places/generate-all-summaries`),
  getSummaryStatus: () => axios.get(`${API}/places/summary-status`),

  // Section Visibility
  getSections: () => axios.get(`${API}/settings/sections`),
  toggleSection: (key, visible) => axios.put(`${API}/settings/sections/${key}`, null, { params: { visible } }),
  
  // Admin
  autoCleanupClosedPlaces: () => axios.post(`${API}/admin/auto-cleanup-closed-places`),
  closedPlacesHistory: () => axios.get(`${API}/admin/closed-places-history`),
  
  // Articles
  getArticles: (params) => axios.get(`${API}/articles`, { params }),
  getArticle: (id) => axios.get(`${API}/articles/${id}`),
  createArticle: (data) => axios.post(`${API}/articles`, data),
  updateArticle: (id, data) => axios.put(`${API}/articles/${id}`, data),
  deleteArticle: (id) => axios.delete(`${API}/articles/${id}`),
  seedArticles: () => axios.post(`${API}/articles/seed`),
  importGoodBarberArticles: () => axios.post(`${API}/articles/import/goodbarber`),
  
  // Itineraries
  updateItinerary: (id, data) => axios.put(`${API}/itineraries/${id}`, data),
  
  // Events
  getEvents: (params) => axios.get(`${API}/events`, { params }),
  getEvent: (id) => axios.get(`${API}/events/${id}`),
  createEvent: (data) => axios.post(`${API}/events`, data),
  updateEvent: (id, data) => axios.put(`${API}/events/${id}`, data),
  patchEvent: (id, data) => axios.patch(`${API}/events/${id}`, data),
  deleteEvent: (id) => axios.delete(`${API}/events/${id}`),
  rescrapeEvent: (id) => axios.post(`${API}/events/${id}/rescrape`),
  generateEventSummary: (id) => axios.post(`${API}/events/${id}/generate-summary`),
  getEventCategories: () => axios.get(`${API}/events/categories/list`),
  importEventbriteEvents: () => axios.post(`${API}/events/import/eventbrite`),
  importTicketmasterEvents: () => axios.post(`${API}/events/import/ticketmaster`),
  importLocalEvents: () => axios.post(`${API}/events/import/local-sources`),
  importLuchaCanariaEvents: () => axios.post(`${API}/events/import/lucha-canaria`),
  importAllEvents: () => axios.post(`${API}/events/import/all`),
  cleanupPastEvents: () => axios.delete(`${API}/events/cleanup-past`),
  
  // Pharmacies
  getDutyPharmacies: (params) => axios.get(`${API}/pharmacies/on-duty`, { params }),
  importPharmacies: () => axios.post(`${API}/pharmacies/import`),
  getPharmacyImportStatus: () => axios.get(`${API}/pharmacies/import-status`),

  // Trails (Senderos)
  getTrails: (params) => axios.get(`${API}/trails`, { params }),
  getTrail: (id, lang) => axios.get(`${API}/trails/${id}`, { params: { lang } }),
  getTrailStats: () => axios.get(`${API}/trails/stats`),
  getTrailMunicipalities: () => axios.get(`${API}/trails/municipalities`),
  getTrailNaturalSpaces: () => axios.get(`${API}/trails/natural-spaces`),
  getActiveTrailAlerts: () => axios.get(`${API}/trails/alerts/active`),
  getWeatherAlerts: () => axios.get(`${API}/trails/alerts/weather`),
  getAlerts: (type, eventId) => axios.get(`${API}/alerts`, { params: { type, event_id: eventId || undefined } }),
  importTrailAlerts: () => axios.post(`${API}/trails/alerts/import`),
  deactivateTrailAlert: (id) => axios.delete(`${API}/trails/alerts/${id}`),
  seedTrailAlerts: () => axios.post(`${API}/trails/alerts/seed`),
  importTrails: () => axios.post(`${API}/trails/import`),
  toggleTrailFeatured: (id, featured) => axios.patch(`${API}/trails/${id}/featured`, { featured }),

  // Seed and updates
  seedDatabase: () => axios.post(`${API}/seed`),
  updateWebcams: () => axios.post(`${API}/update-webcams`),
  retranslateAll: () => axios.post(`${API}/admin/retranslate-all`),

  // Individual translations
  translatePlace: (id) => axios.post(`${API}/translate/place/${id}`),
  translateArticle: (id) => axios.post(`${API}/translate/article/${id}`),
  translateItinerary: (id) => axios.post(`${API}/translate/itinerary/${id}`),
  translateEvent: (id) => axios.post(`${API}/translate/event/${id}`),

  // Batch translations
  translateAllPlaces: () => axios.post(`${API}/translate/all/places`),
  translateAllArticles: () => axios.post(`${API}/translate/all/articles`),
  translateAllItineraries: () => axios.post(`${API}/translate/all/itineraries`),
  translateAllEvents: () => axios.post(`${API}/translate/all/events`),
  translateAllAlerts: () => axios.post(`${API}/translate/all/alerts`),
  getTranslationStats: () => axios.get(`${API}/translate/stats`),

  // Weather briefing (public)
  getTodayBriefing: () => axios.get(`${API}/weather-briefing/today`),

  // Integrations (admin, JWT)
  getIntegrationKeys: () => axios.get(`${API}/admin/integrations/keys`),
  createIntegrationKey: (name) => axios.post(`${API}/admin/integrations/keys`, { name }),
  revokeIntegrationKey: (id) => axios.delete(`${API}/admin/integrations/keys/${id}`),
  getIntegrationLogs: (params) => axios.get(`${API}/admin/integrations/logs`, { params }),
  getIntegrationStats: () => axios.get(`${API}/admin/integrations/stats`),
  getAutomation: () => axios.get(`${API}/admin/automation`),
  setAutomation: (kind, enabled) => axios.put(`${API}/admin/automation/${kind}`, { enabled }),
  setContentStatus: (resource, id, status) => axios.post(`${API}/admin/content/${resource}/${id}/status`, { status }),
};
